import React from 'react';

import { Carousel } from 'react-responsive-carousel';

import workInProgress from '../Images/work_in_progress.jpg';

import roadImage from '../Images/glasphalt_gv.jpg';
import asphalt from '../Images/asphalt.jpg';
import road from '../Images/kal_road.jpg';
import zoomroad from '../Images/zoom_road.jpg';

const carouselData = [
  { img: asphalt, text: 'ho' },
  { img: zoomroad, text: 'text' },
  { img: road, text: 'dodo' },
  { img: workInProgress, text: 'dodo' },
  { img: roadImage, text: 'dodo' },
];

const data = carouselData.map((info, index) => {
  return (
    <div>
      <img src={`${info.img}`} />
      {/* <p className="legend">{info.text}</p> */}
    </div>
  );
});

const CarouselComponent = () => {
  return <Carousel dynamicHeight>{data}</Carousel>;
};

export default CarouselComponent;
